/** Download is always an explicit action; preview components never navigate to file URLs. */
export function triggerDownload(url: string, fileName?: string) {
  const link = document.createElement('a')
  link.href = url
  if (fileName) link.download = fileName
  link.rel = 'noreferrer'
  document.body.appendChild(link)
  link.click()
  link.remove()
}
